/* eslint-disable react/button-has-type */
/* prettier-ignore */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Label } from 'components/atoms';
import { Form, Input } from 'components/atoms/_common';
import { Row } from 'components/atoms/_util';
import { CompanyDetails } from 'context/CreateCompanyStepper/types';
import { format } from 'date-fns';
import React from 'react';
import { CREATE_COMPANY_SCHEMA } from 'util/schemas';

interface Props {
  defaultValues: CompanyDetails;
  setCompanyDetails: (companyDetails: CompanyDetails) => void;
}

const CompanyDetailsForm = React.forwardRef(
  (
    { defaultValues, setCompanyDetails }: Props,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    const handleSubmitDetails = ({
      date_formed,
      fiscal_year_end_date,
      primary_email,
      phone,
    }) => {
      setCompanyDetails({
        date_formed,
        fiscal_year_end_date,
        primary_email,
        phone,
      });
    };

    return (
      <Form
        ref={ref}
        schema={CREATE_COMPANY_SCHEMA.information.companyDetails}
        onSubmit={handleSubmitDetails}
        defaultValues={defaultValues}
      >
        <Label text="Company details" iconName="corporate_fare" />
        <Row breakRowOnMobile>
          <Input
            max={format(new Date(), 'yyyy-MM-dd')}
            type="date"
            name="date_formed"
            label="Date formed"
          />
          <Input
            type="date"
            name="fiscal_year_end_date"
            label="Fiscal Year End"
          />
        </Row>
        <Row breakRowOnMobile>
          <Input name="phone" label="Phone number" />
          <Input name="primary_email" label="Contact email" />
        </Row>
      </Form>
    );
  }
);

export default CompanyDetailsForm;
